// extracted by mini-css-extract-plugin
export var messageSideLeft = "_or-1";
export var messageSideRight = "_or-2";
export var orderLookupBubbleContainer = "_or-0";
export var submitButton = "_or-3";